import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { initializeSentry } from './utils/sentry.js';
import App from './App.jsx';
import './index.css';

// Initialize Sentry before rendering React
initializeSentry();
registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
